"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fixContactPrefLinks = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _split6 = _interopRequireDefault(require("lodash/split"));
var _react = _interopRequireDefault(require("react"));
var _angieslistAppPlatform = require("angieslist-app-platform");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var a = function a(text, url) {
  return /*#__PURE__*/_react["default"].createElement("a", {
    target: "_blank",
    rel: "noopener noreferrer",
    href: url
  }, text);
};
var userAgreement = a('Service Provider\'s User Agreement', _angieslistAppPlatform.urlCatalog.global.serviceProviderUserAgreement());
var privacyPolicy = a('Privacy Policy', _angieslistAppPlatform.urlCatalog.global.privacyPolicy());
var fixContactPrefLinks = exports.fixContactPrefLinks = function fixContactPrefLinks(pref, appName) {
  if (pref.key === 'message_center_sms' || pref.key === 'telephone' && appName === 'office-app') {
    var _split2 = (0, _split6["default"])(pref.description, 'Service Provider\'s User Agreement'),
      _split3 = (0, _slicedToArray2["default"])(_split2, 2),
      beginning = _split3[0],
      rest = _split3[1];
    var _split4 = (0, _split6["default"])(rest, 'Privacy Policy'),
      _split5 = (0, _slicedToArray2["default"])(_split4, 2),
      middle = _split5[0],
      end = _split5[1];
    var newDesc = /*#__PURE__*/_react["default"].createElement("p", null, beginning, userAgreement, middle, privacyPolicy, end);
    return _objectSpread({}, _objectSpread(_objectSpread({}, pref), {}, {
      description: newDesc
    }));
  } else {
    return pref;
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/account-ion/lib/modules/common/browser/components/myAccount/fixContactPrefLinks.js
// module id = 2102
// module chunks = 9